export default __webpack_public_path__ + "static/media/pass.e95d9574.png";